import { render, staticRenderFns } from "./CheckTypeASelector.vue?vue&type=template&id=501ad08e&scoped=true"
import script from "./CheckTypeASelector.vue?vue&type=script&lang=js"
export * from "./CheckTypeASelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501ad08e",
  null
  
)

export default component.exports